import { render, staticRenderFns } from "./processSettings.vue?vue&type=template&id=9cb9537e&scoped=true"
import script from "./processSettings.vue?vue&type=script&lang=js"
export * from "./processSettings.vue?vue&type=script&lang=js"
import style0 from "./processSettings.vue?vue&type=style&index=0&id=9cb9537e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb9537e",
  null
  
)

export default component.exports